import { render } from "./HomeworkCreationForm.vue?vue&type=template&id=2f43ef8c&scoped=true"
import script from "./HomeworkCreationForm.vue?vue&type=script&lang=js"
export * from "./HomeworkCreationForm.vue?vue&type=script&lang=js"

import "./HomeworkCreationForm.vue?vue&type=style&index=0&id=2f43ef8c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f43ef8c"]])

export default __exports__